import TransactionsLog from 'components/transactionLog';

const TransactionsLogPage = () => {
  return <TransactionsLog />;
};

export default TransactionsLogPage;
